import { formatDate } from '../../../../lib/utils/date/formatDate';
import { DATE_FORMAT } from '../../../../types/common/date';

/**
 * 금액 컬럼 공통 포맷터.
 * 숫자면 ko-KR locale 로 콤마 구분, undefined/null 이면 '-'.
 */
export const formatAmount = (v?: number): string =>
  typeof v === 'number' ? v.toLocaleString('ko-KR') : '-';

/**
 * 날짜시간 컬럼 공통 포맷터 — `YYYY-MM-DD HH:mm:ss`.
 * 기존 정산 리스트와 톤 맞춤 (오전/오후 표기 X).
 */
export const formatDateTime = (v?: string): string =>
  formatDate(v, DATE_FORMAT.FULL_DASH_FORMAT);
